var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6374_5193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5754 5.72278L10.6568 4.97145L8.4521 0.275451C8.28743 -0.0752155 7.7121 -0.0752155 7.54743 0.275451L5.34343 4.97145L0.424766 5.72278C0.0207661 5.78478 -0.140567 6.27612 0.142766 6.56612L3.7161 10.2288L2.87143 15.4068C2.8041 15.8181 3.24343 16.1268 3.60677 15.9248L8.0001 13.4968L12.3934 15.9255C12.7534 16.1255 13.1968 15.8228 13.1288 15.4075L12.2841 10.2295L15.8574 6.56678C16.1408 6.27612 15.9788 5.78478 15.5754 5.72278Z",
    fill: "url(#paint0_linear_6374_5193)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6374_5193",
    x1: -4.36365,
    y1: 15.9886,
    x2: 17.2492,
    y2: 1.93333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DA3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#A685D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC1D7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6374_5193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1ed2178b08e302bfadab5e1d6778f1fa.svg";
export { ForwardRef as ReactComponent };